import { Box, BoxProps, SxProps, Theme } from "@mui/material";
import { Property } from "csstype";
import { TImageLoading } from "src/types/image.types";
import { toSxArray } from "src/utils/mui/sx/sx";
import { buildPictureSources, ISrc } from "src/utils/responsive-image-util";

const PICTURE_SX: SxProps<Theme> = { display: "contents" };
const IMAGE_SX: SxProps<Theme> = { maxWidth: "100%", height: "auto" };

export interface IResponsiveImageProps extends Omit<BoxProps<"img">, "src" | "srcSet" | "alt" | "color" | "component"> {
    baseUrl: string;
    alt: string | null;
    onError?: () => void;
    srcSet?: ISrc[];
    loading?: TImageLoading;
    objectFit?: Property.ObjectFit | Property.ObjectFit[];
    objectPosition?: Property.ObjectPosition | Property.ObjectPosition[];
    sx?: SxProps<Theme>;
}

export const ResponsiveImage = ({
    baseUrl,
    alt,
    srcSet,
    loading = "lazy",
    onError,
    objectFit,
    objectPosition,
    sx,
    ...imageProps
}: IResponsiveImageProps) => {
    const { mediaSources, defaultImage } = buildPictureSources(baseUrl, srcSet);

    return (
        <Box component="picture" sx={PICTURE_SX}>
            {mediaSources.map(mediaSource => (
                <source key={mediaSource.minWidth} media={`(min-width: ${mediaSource.minWidth})`} srcSet={mediaSource.srcSet} />
            ))}
            <Box
                component="img"
                srcSet={defaultImage.srcSet}
                src={defaultImage.src}
                loading={loading}
                alt={alt ?? undefined}
                onError={onError}
                sx={[IMAGE_SX, objectFit ? { objectFit } : null, objectPosition ? { objectPosition } : null, ...toSxArray(sx)]}
                {...imageProps}
            />
        </Box>
    );
};
